import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class MenuItem extends Component {
  render() {
    const {
      menuId,
      menuTitle,
      imageName,
      subMenus,
      headingVisible,
      handleNavLinkClick,
      activeMenuPath,
    } = this.props;
    return (
      <li className="nav-item">
        {headingVisible && (
          <div
            className="nav-link menu-parent-link"
            id={menuId}
            aria-controls={`navbar-${menuId}`}
            style={{ color: "black", cursor: "default" }}
          >
            <i className={imageName} aria-hidden="true" style={{ width: "20px", textAlign: "center" }}></i>
            <span className="nav-link-text">{menuTitle}</span>
          </div>
        )}
        <div className="collapse show" id={`navbar-${menuId}`}>
          <ul className="nav nav-sm flex-column">
            {subMenus
              .filter((x) => x.isChecked === true)
              .map((item) => (
                <li key={item.url} className="nav-item hover-effect">
                  <NavLink
                    to={item.url}
                    className={({ isActive }) =>
                      `nav-link${isActive || activeMenuPath === item.url ? " active" : ""}`
                    }
                    style={{ paddingLeft: "10px", color:"black" }}
                    onClick={() => handleNavLinkClick(false)}
                  >
                    <i
                      className={`fa ${item.icon || "fa-angle-double-right"}`}
                      aria-hidden="true"
                      style={{ minWidth: "1.2rem" }}
                    ></i>
                    <span className="nav-link-text">{item.name}</span>
                  </NavLink>
                </li>
              ))}
          </ul>
        </div>
      </li>
    );
  }
}

export default MenuItem;
